import { makeAutoObservable } from 'mobx';
import { getCityList, getEnCityList, getEnumsByType } from '@src/service';
import { IEnumItem } from '@src/types';

export default class Position {
  // 获取筛选项数据
  data: [IEnumItem[], IEnumItem[], IEnumItem[], IEnumItem[]] = [[], [], [], []];

  filterLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  // 获取职位筛选枚举值
  fetchFilterEnumData = async () => {
    try {
      const needRequest = this.data.some((item) => item.length === 0);
      if (needRequest) {
        this.setFilterLoading(true);
        const res = await Promise.all([
          getCityList({ hotCity: true, keyword: '' }),
          getEnumsByType('JF'),
          getEnumsByType('BG'),
          getEnumsByType('HIRING'),
          getEnumsByType('BEIDOU_HIRING'),
          getEnumsByType('QIHANG_HIRING'),
          getEnCityList(),
        ]);
        // 过滤热门城市-其他
        if (res && Array.isArray(res[0])) {
          res[0] = res[0].filter((item) => item.code !== 'other');
        }
        // JF JG增加全部
        if (res && Array.isArray(res[1])) {
          res[1] = res[1].map((item) => ({
            ...item,
            children: [
              {
                code: '-1',
                name: '全部',
                children: null,
              },
              ...(item.children || []),
            ],
          }));
        }
        // 热门海外城市增加全部
        if (res && Array.isArray(res[6])) {
          res[6] = res[6].map((item) => ({
            ...item,
            children: [
              {
                code: `-1`,
                name: '全部',
                children: null,
              },
              ...(item.children || []),
            ],
          }));
        }
        this.setFilterEnumData(res);
      }
    } catch (error) {
      console.log('error===>', error);
    } finally {
      this.setFilterLoading(false);
    }
  };

  // 设置枚举值
  setFilterEnumData(payload) {
    this.data = payload;
  }

  // 设置筛选条件loading
  setFilterLoading(payload) {
    this.filterLoading = payload;
  }
}
